<template>
        <div>
            <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        tbody-classes="list"
                        :data="projects">
                <template slot="columns">
                <th>N° Projecto</th>
                <th>N° Eje</th>
                <th>Alias</th>
                <th>Descargar</th>
                </template>

                <template slot-scope="{row}">
                <td class="id">
                    {{row.project_n}}
                </td>
                <td class="description">
                    {{row.sector}}
                </td>
                <td class="description">
                    {{row.alias}}
                </td>                
                <td>
                    <base-button type="primary" icon="ni ni-cloud-download-95"
                        v-on:click="delay_download(row.project_n, row.sector)"
                    :disabled="disabled"></base-button>
                </td>
                </template>

            </base-table>
            </div>    
        </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from "vuex";
export default {
    name: "list-projects",
    data () {
      return {
        disabled: false,
        timeout: null
      }
    },
    // TODO, pass an array
    props: ['projects'],
    methods: {
        download(projectNumber, sector) {
            console.log(projectNumber)
            axios({
                url: this.$dirServerDownload,
                method: 'POST',
                responseType: 'blob', // important
                data: {
                    'projecto': projectNumber,
                    'sector': sector
                },
                headers : {
                'Content-Type' : 'application/json',
                'Authorization': 'Bearer ' + this.token,
                },
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `memoria_descriptiva_${projectNumber}_${sector}.pdf`);
                document.body.appendChild(link);
                link.click();
            });
        },
        delay_download (projectNumber, sector) {
            this.disabled = true

            this.timeout = setTimeout(() => {
            this.disabled = false
            }, 2000)

            this.download(projectNumber, sector)
        },
        beforeDestroy () {
            // clear the timeout before the component is destroyed
            clearTimeout(this.timeout)
        }
    },
    computed: {
        ...mapGetters({
        user: "user"
        }),
        ...mapGetters({
        token: "token"
        })
    },
}
</script>
<style>
</style>
